// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { linkListStyles } from "@west/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@west/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.titleWrapper = {
    css: css`
        display: flex;
        margin-bottom: 8px;
    `,
};

linkListStyles.titleLink = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        lineHeight: "20px",
        css: css`
            letter-spacing: 0;
            font-family: ${fontConfig.headingFontFamily};
        `,
    },
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

linkListStyles.link = {
    hoverStyle: {
        color: getSystemColor("common.ui9"),
    },
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        lineHeight: "14px",
        css: css`
            letter-spacing: 0;
            font-family: ${fontConfig.bodyFontFamily};
        `,
    },
    css: css`
        &:focus {
            outline: none;
        }
        & > ${IconWrapper} {
            margin-right: 8px;
            &,
            & > svg {
                width: 18px;
                height: 14px;
                color: ${color("common.ui4")};
            }
        }
    `,
};
